const setNewProductsBadge = (productIds, restockProductsIds) => {
  console.log("restockProductsIds", restockProductsIds);
  // check if restockedProducts is an array
  if (
    restockProductsIds &&
    Array.isArray(restockProductsIds) &&
    restockProductsIds.length
  ) {
    [...new Set(restockProductsIds)].map((pId) => {
      // find div with data-badges-product equal to pId
      const el = document.querySelector(`[data-badges-product="${pId}"]`);
      if (el) {
        if (el.querySelector(".sold-out-badge")) {
          return;
        }

        if (el.querySelector(".room-restocking-soon")) {
          return;
        }

        const sp = document.createElement("span");
        sp.innerText = "RECENTLY RESTOCKED";
        el.appendChild(sp);
      }
    });
  }

  // check if productIds is an array
  if (productIds && Array.isArray(productIds) && productIds.length) {
    productIds.map((pId) => {
      // find div with data-badges-product equal to pId
      const el = document.querySelector(`[data-badges-product="${pId}"]`);
      if (el) {
        if (el.querySelector(".sold-out-badge")) {
          return;
        }
        const sp = document.createElement("span");
        sp.classList.add("new-badge");
        sp.innerText = "new";
        el.appendChild(sp);
      }
    });
  }
};

// TODO: move all coming soon calls here. and save to session storage so we only do call once.
const addComingSoonBadges = (products) => {
  console.log("addComingSoonBadges", products);
  // data-badges-product
  products.map((p) => {
    // check if we are on PDP
    const restockPdp = document.querySelector(
      `[data-product-restock="${p.id}"]`,
    );
    if (restockPdp) {
      console.log("pppp", p);
      const date = new Date(p.date);
      const message =
        "<p>Sold out in your size or product? Subscribe for a restock notification.</p>";
      // check if date more than one year in future
      if (
        date > new Date(new Date().setFullYear(new Date().getFullYear() + 1))
      ) {
        restockPdp.innerHTML = "<h4>Restocking soon .</h4>" + message;
        return;
      }

      restockPdp.innerHTML =
        "<h4>RESTOCK: " +
        date
          .toLocaleDateString("en-US", {
            day: "numeric",
            month: "short",
            year: "numeric",
          })
          .toUpperCase() +
        " 8PM CET</h4>" +
        message;
    }
    // find prodcut cards by data-badges-product equales p.id
    document
      .querySelectorAll(`[data-badges-product="${p.id}"]`)
      .forEach((el) => {
        if (!p.isRestock) {
          return;
        }

        // TODO: check if its a restock!
        const sp = document.createElement("span");

        sp.classList.add("room-restocking-soon");
        sp.innerText = "restocking soon";
        //  sp.innerText = "RECENTLY RESTOCKED";
        el.appendChild(sp);

        // if el has soldout badge, remove;
        const soldout = el.querySelector(".sold-out-badge");
        if (soldout) {
          soldout.remove();
        }
      });
  });
};

const klaviyoPublicKey = "YurRAQ";

const activateNotifyButtons = () => {
  const usersEmail = window.roomCustomerEmail || window.wish?.email || "";

  const buildNotifyModal = () => {
    let modal = document.getElementById("coming-soon-notify-modal");
    if (modal) {
      return modal;
    }

    const modalMarkup = `
      <div id="coming-soon-notify-modal" class="coming-soon-notify-modal" style="display:none;">
        <div class="coming-soon-notify-modal__panel" role="dialog" aria-modal="true" aria-labelledby="coming-soon-notify-title">
          <button type="button" class="coming-soon-notify-modal__close" aria-label="Close">&times;</button>
          <h3 id="coming-soon-notify-title" class="coming-soon-notify-modal__title"></h3>
          <p class="coming-soon-notify-modal__text">Register to receive a notification when this item comes back in stock.</p>
          <div class="coming-soon-notify-modal__field">
            <select id="coming-soon-notify-size"></select>
          </div>
          <div class="coming-soon-notify-modal__field">
            <input id="coming-soon-notify-email" type="email" placeholder="Email" autocomplete="email" required>
          </div>
          <label class="coming-soon-notify-modal__optin" for="coming-soon-notify-optin">
            <input id="coming-soon-notify-optin" type="checkbox" checked>
            <span>Become a Roomie now & don't miss a thing!</span>
          </label>
          <p id="coming-soon-notify-error" class="coming-soon-notify-modal__error" style="display:none;"></p>
          <button type="button" class="button coming-soon-notify-modal__submit">Notify me when available</button>
        </div>
      </div>
    `;

    document.body.insertAdjacentHTML("beforeend", modalMarkup);
    document.body.insertAdjacentHTML(
      "beforeend",
      `<style>
        .coming-soon-notify-modal {
          position: fixed;
          inset: 0;
          z-index: 99999;
          background: rgba(0, 0, 0, 0.45);
        }
        .coming-soon-notify-modal__panel {
          width: min(90vw, 560px);
          max-height: 90vh;
          overflow-y: auto;
          background: #fff;
          margin: 8vh auto;
          padding: 24px 24px;
          position: relative;
        }
        .coming-soon-notify-modal__close {
          position: absolute;
          top: 12px;
          right: 14px;
          background: transparent;
          border: 0;
          color: #b5b5b5;
          font-size: 36px;
          line-height: 1;
          cursor: pointer;
        }
        .coming-soon-notify-modal__title {
          margin: 0 0 12px;
          font-size: 32px;
          line-height: 1.15;
          font-weight: 500;
          letter-spacing: -0.02em;
        }
        .coming-soon-notify-modal__text {
          margin: 0 0 18px;
          font-size: 16px;
        }
        .coming-soon-notify-modal__field {
          margin-bottom: 12px;
        }
        .coming-soon-notify-modal__field select,
        .coming-soon-notify-modal__field input {
          width: 100%;
          min-height: 54px;
          border: 1px solid #cbcbcb;
          padding: 10px 14px;
          font-size: 16px;
          color: #333;
          border-radius: 0;
          background: #fff;
        }
        .coming-soon-notify-modal__submit {
          width: 100%;
          margin-top: 4px;
          min-height: 56px;
          font-size: 16px;
          font-weight: 600;
        }
        .coming-soon-notify-modal__optin {
          display: flex;
          align-items: center;
          gap: 10px;
          margin: 0 0 14px;
          font-size: 16px;
          cursor: pointer;
          color: #222;
        }
        .coming-soon-notify-modal__optin input {
          width: 22px;
          height: 22px;
          margin: 0;
          accent-color: #757575;
          cursor: pointer;
        }
        .coming-soon-notify-modal__error {
          color: #c40000;
          margin: 0 0 10px;
          font-size: 14px;
        }
        @media (max-width: 989px) {
          .coming-soon-notify-modal__panel {
            width: min(95vw, 540px);
            padding: 26px 22px;
          }
          .coming-soon-notify-modal__title {
            font-size: 22px;
            margin-bottom: 14px;
          }
          .coming-soon-notify-modal__text {
            font-size: 15px;
            margin-bottom: 20px;
          }
          .coming-soon-notify-modal__field select,
          .coming-soon-notify-modal__field input {
            min-height: 52px;
            padding: 10px 14px;
            font-size: 16px;
          }
        }
      </style>`,
    );

    modal = document.getElementById("coming-soon-notify-modal");
    modal.addEventListener("click", (event) => {
      if (event.target === modal) {
        modal.style.display = "none";
      }
    });

    const closeButton = modal.querySelector(".coming-soon-notify-modal__close");
    closeButton.addEventListener("click", () => {
      modal.style.display = "none";
    });

    return modal;
  };

  const notifyState = {
    variantId: "",
    productTitle: "",
    selectHtml: "",
    isRestock: null,
    sourceButton: null,
  };

  const getNotifyContextFromButton = (button) => {
    if (!button) {
      return null;
    }

    let variantId = button.dataset.variantid || "";
    const selectEl = button.parentElement
      ? button.parentElement.querySelector("select")
      : null;

    if (selectEl && selectEl.value) {
      variantId = selectEl.value;
    }

    const titleEl = button
      .closest(".card-wrapper, .notify-grid-item")
      ?.querySelector(".card__heading a, .card__heading");
    const isRestockFromDataset = button.dataset.isrestock;
    let isRestock = null;

    if (isRestockFromDataset === "true") {
      isRestock = true;
    } else if (isRestockFromDataset === "false") {
      isRestock = false;
    } else {
      const productByVariant =
        window.comingSoonProducts &&
        window.comingSoonProducts.find(
          (product) =>
            product.variantId === variantId ||
            (Array.isArray(product.variants) &&
              product.variants.some((variant) => variant.id === variantId)),
        );
      if (productByVariant && typeof productByVariant.isRestock === "boolean") {
        isRestock = productByVariant.isRestock;
      }
    }

    return {
      variantId,
      productTitle: titleEl ? titleEl.textContent.trim() : "Notify me",
      selectHtml: selectEl ? selectEl.innerHTML : "",
      isRestock,
      sourceButton: button,
    };
  };

  const getNotifyContextFromLink = (link) => {
    const wrapper = link.closest(".card-wrapper, .notify-grid-item");
    const button = wrapper ? wrapper.querySelector(".notify-button") : null;
    if (!button) {
      return null;
    }
    return getNotifyContextFromButton(button);
  };

  const isValidEmail = (email) => {
    return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      String(email).toLowerCase(),
    );
  };

  const openNotifyModal = (context) => {
    if (!context || !context.variantId) {
      return;
    }

    notifyState.variantId = context.variantId;
    notifyState.productTitle = context.productTitle;
    notifyState.selectHtml = context.selectHtml;
    notifyState.isRestock = context.isRestock;
    notifyState.sourceButton = context.sourceButton;

    const modal = buildNotifyModal();
    const titleEl = modal.querySelector(".coming-soon-notify-modal__title");
    const helperTextEl = modal.querySelector(".coming-soon-notify-modal__text");
    const sizeSelectEl = modal.querySelector("#coming-soon-notify-size");
    const emailInputEl = modal.querySelector("#coming-soon-notify-email");
    const optinEl = modal.querySelector("#coming-soon-notify-optin");
    const errorEl = modal.querySelector("#coming-soon-notify-error");
    const submitEl = modal.querySelector(".coming-soon-notify-modal__submit");

    titleEl.textContent = context.productTitle || "Notify me";
    sizeSelectEl.innerHTML =
      context.selectHtml ||
      `<option value="${context.variantId}">Default</option>`;
    if (context.variantId) {
      sizeSelectEl.value = context.variantId;
    }
    if (notifyState.isRestock === true) {
      helperTextEl.textContent =
        "Register to receive a notification when this item comes back in stock.";
    } else if (notifyState.isRestock === false) {
      helperTextEl.textContent =
        "Register to receive a notification when this item drops.";
    } else {
      helperTextEl.textContent =
        "Register to receive a notification when this item drops or comes back in stock.";
    }
    emailInputEl.value = usersEmail;
    if (optinEl) {
      optinEl.checked = true;
    }
    errorEl.style.display = "none";
    errorEl.textContent = "";
    submitEl.disabled = false;
    submitEl.textContent = "Notify me when available";
    modal.style.display = "block";
  };

  const submitEl = buildNotifyModal().querySelector(
    ".coming-soon-notify-modal__submit",
  );
  if (submitEl.classList.contains("js-coming-soon-submit-initialized")) {
    return;
  }
  submitEl.classList.add("js-coming-soon-submit-initialized");

  submitEl.addEventListener("click", () => {
    const modal = document.getElementById("coming-soon-notify-modal");
    const sizeSelectEl = modal.querySelector("#coming-soon-notify-size");
    const emailInputEl = modal.querySelector("#coming-soon-notify-email");
    const optinEl = modal.querySelector("#coming-soon-notify-optin");
    const errorEl = modal.querySelector("#coming-soon-notify-error");
    const selectedVariant = sizeSelectEl.value || notifyState.variantId;
    const email = emailInputEl.value.trim();
    const acceptsMarketing = !!(optinEl && optinEl.checked);

    if (!isValidEmail(email)) {
      errorEl.textContent = "Please enter a valid email address.";
      errorEl.style.display = "block";
      return;
    }

    errorEl.style.display = "none";
    submitEl.disabled = true;
    submitEl.textContent = "Sending...";

    const dataFromLocalStorage =
      JSON.parse(localStorage.getItem("klaviyoComingSoon")) || {};
    dataFromLocalStorage[selectedVariant] = true;
    localStorage.setItem(
      "klaviyoComingSoon",
      JSON.stringify(dataFromLocalStorage),
    );

    const body = {
      a: klaviyoPublicKey,
      email,
      variant: selectedVariant.replace("gid://shopify/ProductVariant/", ""),
      platform: "shopify",
      accepts_marketing: acceptsMarketing,
    };

    fetch("https://the-room-app.vercel.app/api/subscribe", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    }).then((response) => {
      if (response.status === 202) {
        submitEl.textContent = "You will be notified!";
        if (notifyState.sourceButton) {
          notifyState.sourceButton.innerHTML = "You will be notified";
          notifyState.sourceButton.disabled = true;
        }
        setTimeout(() => {
          modal.style.display = "none";
        }, 600);
      } else {
        submitEl.disabled = false;
        submitEl.textContent = "Notify me when available";
        errorEl.textContent = "Something went wrong. Please try again.";
        errorEl.style.display = "block";
      }
    });
  });

  Array.from(
    document.querySelectorAll(
      ".js-coming-soon-notify-link:not(.js-notify-link-initialized)",
    ),
  ).forEach((link) => {
    link.classList.add("js-notify-link-initialized");
    link.addEventListener("click", (e) => {
      e.preventDefault();
      openNotifyModal(getNotifyContextFromLink(e.currentTarget));
    });
  });

  Array.from(
    document.querySelectorAll(".notify-button:not(.js-notify-initialized)"),
  ).forEach((btn) => {
    btn.classList.add("js-notify-initialized");
    // check if has been clicked
    const dataFromLocalStorage =
      JSON.parse(localStorage.getItem("klaviyoComingSoon")) || {};
    if (dataFromLocalStorage[btn.dataset.variantid]) {
      btn.innerHTML = "You will be notified";
      btn.disabled = true;
    }
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      openNotifyModal(getNotifyContextFromButton(e.currentTarget));
    });
  });
};

const fillCarousel = (x) => {
  window.comingSoonProducts = x;
  const carroussel = document.getElementById("Banner-comming-soon");
  if (!carroussel) return;

  const showNotify = carroussel.dataset.showNotify === "true";
  const enableNotifyFeatures = showNotify;

  const commm = `  <li id="Slide-template--{{ section.id }}-1" class="grid__item slider__slide slider--desktop">
    <div class="card-wrapper product-card-wrapper underline-links-hover">
      <div
        class="
          card
          card--standard
           card--media
        "
        style="--ratio-percent: 125.0%;"
      >
        <div class="card__inner color-background-2 gradient ratio" style="--ratio-percent: 125.0%;">
          <div class="card__media">
        
            <div class="infoButton drop-date">RRRDATERRR</div>
            <div class="media media--transparent media--hover-effect">
              <img
                src="RRRIMGRRR"
                alt="Air Motor Longsleeve Blue"
                class="motion-reduce"
                loading="lazy"
                width="480"
                height="600"
              >
            </div>
          </div>
          <div class="card__content">
            <div class="card__information">
              <h3 class="card__heading">
                <a
                  href="/pages/coming-soon"
                  class="full-unstyled-link"
                >
                  RRRTITLERRR
                </a>
              </h3>
            </div>
            <div class="card__badge bottom left"></div>
          </div>
        </div>
        <div class="card__content">
          <div class="card__information">
            <h3 class="card__heading h5">
              <a
                href="/pages/coming-soon"
                class="full-unstyled-link"
              >
                RRRTITLERRR
              </a>
            </h3>
            <div class="card-information">
              <span class="caption-large light"></span>
              <div class="price ">
                <div class="price__container">
                  <div class="price__regular">
                    <span class="visually-hidden visually-hidden--inline">Regular price</span>
                    <span class="price-item price-item--regular"> RRRPRICERRR ${Shopify?.currency?.active}</span>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
           RRRNOTIFYBLOCK
          <div class="card__badge bottom left"></div>
        </div>
      </div>
    </div>
  </li>`;
  if (x.filter((p) => !p.title.startsWith("POS ")).length === 0) {
    document.getElementById("Banner-comming-soon").style.display = "none";
  }

  const filterTag = carroussel.dataset.tagFilter;
  if (filterTag) {
    x = x.filter((p) => p.tags && p.tags.includes(filterTag));
  }
  x.filter((p) => !p.title.startsWith("POS "))
    .sort((a, b) => {
      return new Date(a.date) < new Date(b.date) ? -1 : 1;
    })
    .forEach((product) => {
      let selectio = "<select>";
      product.variants.map((v) => {
        selectio += `<option value="${v.id}">${v.title}</option>`;
      });
      selectio += "</select>";
      // format date
      // add 20 hours to the date to fix timezone
      product.date = new Date(product.date);
      product.date.setHours(product.date.getHours() + 20);

      const date = new Date(product.date).toLocaleDateString("en-US", {
        day: "numeric",
        month: "short",
        year: "numeric",
      });

      // format date
      let preffixx = product.isRestock ? "RESTOCK" : "DROP";
      let dateTime = date == "Invalid Date" ? "" : `${preffixx} ${date}`;

      // if dateTime is over 1 Year, just show the drop title

      if (
        product.date >
        new Date(new Date().setFullYear(new Date().getFullYear() + 1))
      ) {
        dateTime = product.droptitle;
        suffixx = "";
      }

      let notifyBlock = "";
      if (enableNotifyFeatures) {
        notifyBlock = `<div>
            <div class="select-varri">RRRSELECTIO</div>
            <button class="button notify-button" data-variantid="RRRVARRRR" data-isrestock="RRRISRESTOCKRRR">Notify me when it drops</button>
          </div>`;
      }

      let productHtml = commm
        .replace("RRRIMGRRR", product.image)
        .replaceAll("RRRTITLERRR", product.title)
        .replace(
          "RRRPRICERRR",
          product.price.replace(".0", ",00").replace("000", "00"),
        )
        .replace("RRRNOTIFYBLOCK", notifyBlock)
        .replace("RRRVARRRR", product.variantId)
        .replace("RRRISRESTOCKRRR", product.isRestock ? "true" : "false")
        .replace("RRRIMGVARRRR", product.variantId)
        .replace("RRRSELECTIO", selectio)

        .replace("RRRDATERRR", product.date ? dateTime : "")
        .replaceAll("NUMBEROFIMAGES", product.images.length);

      if (enableNotifyFeatures) {
        productHtml = productHtml.replaceAll(
          'href="/pages/coming-soon"',
          'href="javascript:void(0)" class="js-coming-soon-notify-link"',
        );
      }

      document.querySelector("#Banner-comming-soon ul").innerHTML +=
        productHtml;
    });

  activateNotifyButtons();
};
const fillComingsoonPage = (x) => {
  const pathName = window.location.pathname;
  if (!pathName.includes("pages/coming-soon")) {
    if (!pathName.includes("e-room-of-elise")) {
      if (!pathName.includes("os-angeles-drop")) {
        return;
      }
    }
  }

  const productGrid = document.querySelector("#product-grid");
  if (productGrid) {
    const filterTag = productGrid.dataset.tagFilter;
    if (filterTag) {
      x = x.filter((p) => p.tags && p.tags.includes(filterTag));
    }
  }

  const comingSoonTemplate = ` <li class="grid__item notify-grid-item">

    <div class="card-wrapper product-card-wrapper underline-links-hover">
      
        <div class="
            card
            card--standard
             card--media" style="--ratio-percent: 125.0%;">
             <div class="card__inner color-background-2 gradient ratio" style="--ratio-percent: 125.0%;">
              <div class="card__media">
             
                <div class="infoButton drop-date">RRRDATERRR</div>
              <div class="infoPanel">RRRDESCRVARRRR<button class="close">&times;</button></div>
              <div class="counter_dots numberOfDotsNUMBEROFIMAGES">
                <span class="active"></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </div>
              <div class="counter_arrows numberOfDotsNUMBEROFIMAGES">
              <button class="prev prev-image">
                <svg fill="currentColor" width="20px" height="20px" viewBox="0 0 256 256" id="Flat" xmlns="http://www.w3.org/2000/svg">
                  <path d="M160,220a11.96287,11.96287,0,0,1-8.48535-3.51465l-80-80a12.00062,12.00062,0,0,1,0-16.9707l80-80a12.0001,12.0001,0,0,1,16.9707,16.9707L96.9707,128l71.51465,71.51465A12,12,0,0,1,160,220Z"/>
                </svg>
              </button>
              <button class="next next-image">
                <svg fill="currentColor" width="20px" height="20px" viewBox="0 0 256 256" id="Flat" xmlns="http://www.w3.org/2000/svg">
                <path d="M160,220a11.96287,11.96287,0,0,1-8.48535-3.51465l-80-80a12.00062,12.00062,0,0,1,0-16.9707l80-80a12.0001,12.0001,0,0,1,16.9707,16.9707L96.9707,128l71.51465,71.51465A12,12,0,0,1,160,220Z"/>
              </svg>
            </button>
        
              </div>
              <button class="big-image">
                <svg fill="currentColor" height="800px" width="800px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                  viewBox="0 0 490.8 490.8" xml:space="preserve">
               <g>
                 <g>
                   <path d="M364.8,299.55c46.3-75.8,36.9-176.3-28.6-241.9c-76.8-76.8-201.8-76.8-278.6,0s-76.8,201.8,0,278.5
                     c65.5,65.5,166,74.9,241.9,28.6L412,477.25c18,18,47.3,18,65.3,0s18-47.3,0-65.3L364.8,299.55z M295.5,295.55
                     c-54.4,54.4-142.8,54.4-197.1,0c-54.4-54.4-54.4-142.8,0-197.1c54.4-54.4,142.8-54.4,197.1,0
                     C349.8,152.75,349.8,241.15,295.5,295.55z M220,171.95h59.4v45.3H220v59.4h-45.3v-59.4h-59.3v-45.3h59.4v-59.4h45.3v59.4H220z"/>
                 </g>
               </g>
               </svg>
              

              </button>
              <div class="media media--transparent media--hover-effect">
                
                
          <img data-variantid="RRRIMGVARRRR" src="RRRIMGRRR" alt="" class="motion-reduce" style="position:static" loading="lazy" width="1536" height="2049"></div>
              </div><div class="card__content">
       
              <div class="card__badge bottom left"></div>
            </div>
          </div>
          <div class="card__content">
            <div class="card__information">
              <h3 class="card__heading h5" id="title-template--16668097741059__product-grid-7896481759491">
                <a id="CardLink-template--16668097741059__product-grid-7896481759491" class="full-unstyled-link" aria-labelledby="CardLink-template--16668097741059__product-grid-7896481759491 Badge-template--16668097741059__product-grid-7896481759491">
                 RRRTITLERRR
                </a>
              </h3>
              <div class="card-information"><span class="caption-large light"></span>
    <div class="price ">
      <div class="price__container"><div class="price__regular">
          <span class="visually-hidden visually-hidden--inline">Regular price</span>
          <span class="price-item price-item--regular">
            RRRPRICERRR ${Shopify?.currency?.active}
          </span>
         
        </div>
   
     
      </div></div>
    
              </div>
            </div><div class="card__badge bottom left"></div>
          </div>
        </div>
      </div>
      <div>
   <div class="select-varri">RRRSELECTIO</div>
      <button style="margin-top:1rem" class="button notify-button" data-variantid="RRRVARRRR" data-isrestock="RRRISRESTOCKRRR">
        Notify me when it drops
      </button></div>
      <div class="notify-size-selector"></div>
      <a class="button pre-access-link hide"  href="https://theroomantwerp.com/products/RRRHANDLERRR">
        Get pre-access
      </a> 
      
                    </li>`;

  const buttonTemplate = `   <button style="margin-top:1rem" class="button notify-size-button" data-variantid="RRRVARRRR">
                      RRRTXTRRR
                    </button>`;

  let toFormatedCurrency = new Intl.NumberFormat("nl-BE", {
    style: "currency",
    currency: "EUR",
  });

  let currentTitle = "";
  let currentCounter = 0;
  let currentId = "grid__";
  const usersEmail = window.wish?.email;

  window.comingSoonProducts = x;

  x.filter((p) => !p.title.startsWith("POS "))
    .filter((p) => !p.title.startsWith("PREORDER"))
    .forEach((product, inndexx) => {
      const description =
        // product.variants
        //   .map(
        //     (v) =>
        //       v.title +
        //       " - " +
        //       v.price.replace(".00", ".0").replace(".0", ",00") +
        //       " " +
        //       Shopify?.currency?.active
        //   )
        //   .join("<br/>") +
        // "<br/><br/>" +
        product.description || "Description coming soon...";
      let selectio = "<select>";
      product.variants.map((v) => {
        selectio += `<option value="${v.id}">${v.title}</option>`;
      });
      selectio += "</select>";
      // if(product.variants.length == 1){
      //   selectio = "";
      // }
      product.date = new Date(product.date);
      product.date.setHours(product.date.getHours() + 20);
      // format date
      const date = new Date(product.date).toLocaleDateString("en-US", {
        day: "numeric",
        month: "short",
        year: "numeric",
      });

      let preffixx = product.isRestock ? "RESTOCK" : "DROP";
      let suffixx = " 8PM CET.";
      let dateTime = date == "Invalid Date" ? "" : `${preffixx}: ${date} `;
      // if dateTime is over 1 Year, just show the drop title

      if (
        product.date >
        new Date(new Date().setFullYear(new Date().getFullYear() + 1))
      ) {
        dateTime = product.droptitle;
        suffixx = "";
      }

      if (currentTitle != dateTime) {
        let closingTag = "";
        let preffixNew = product.isRestock ? "" : "NEW ";
        currentCounter++;
        if (currentTitle != "") {
          closingTag = "</ul>";
        }

        currentTitle = dateTime;
        if (currentTitle.includes("DROP")) {
          if (
            product.date >
            new Date(new Date().setFullYear(new Date().getFullYear() + 1))
          ) {
            preffixNew = "";
          }
        }
        document.querySelector("#product-grid").innerHTML +=
          closingTag +
          "<h2 style='margin-top: 4rem; margin-bottom: 1rem;'>" +
          preffixNew +
          dateTime +
          suffixx +
          "</h2><ul id='griddd-" +
          currentCounter +
          "' class='grid product-grid grid--2-col-tablet-down grid--4-col-desktop'>";
      } else {
        if (inndexx === 0) {
          let preffixNew = product.isRestock ? "" : "NEW ";
          let closingTag = "";
          document.querySelector("#product-grid").innerHTML +=
            closingTag +
            "<h2 style='margin-top: 4rem; margin-bottom: 1rem;'>" +
            preffixNew +
            dateTime +
            suffixx +
            "</h2><ul id='griddd-" +
            currentCounter +
            "' class='grid product-grid grid--2-col-tablet-down grid--4-col-desktop'>";
        }
      }

      const productHtml = comingSoonTemplate
        .replace("RRRIMGRRR", product.image)
        .replace("RRRTITLERRR", product.title)
        .replace("RRRPRICERRR", product.price.replace(".0", ",00"))
        .replace(",000", ",00")
        .replace("RRRVARRRR", product.variantId)
        .replace("RRRISRESTOCKRRR", product.isRestock ? "true" : "false")
        .replace("RRRIMGVARRRR", product.variantId)
        .replace("RRRHANDLERRR", product.handle)
        .replace("RRRDATERRR", product.date ? dateTime : "")
        .replace("RRRDESCRVARRRR", description)
        .replaceAll("NUMBEROFIMAGES", product.images.length)
        .replace("RRRSELECTIO", selectio);

      window[product.variantId] = product.images;
      document.querySelector("#griddd-" + currentCounter).innerHTML +=
        productHtml;
    });
  // check if we have no results
  if (x.filter((p) => !p.title.startsWith("POS ")).length === 0) {
    document.querySelector("#fetching").innerHTML = "Nothing here...";
  } else {
    // console.log(x);
    document.querySelector("#fetching").style.display = "none";
  }

  const klaviyoPublicKey = "YurRAQ";

  //add eventlistener for next image
  document.querySelectorAll(".next-image").forEach((yy) => {
    yy.addEventListener("click", () => {
      // get the image from the button
      const x = yy.parentElement.parentElement.querySelector(".media img");
      const variantId = x.dataset.variantid;
      const images = window[variantId];
      const currentImage = x.src;
      const currentIndex = images.indexOf(currentImage);
      const nextIndex = currentIndex + 1;
      const nextImage = images[nextIndex];
      const allSpans =
        x.parentElement.parentElement.querySelectorAll(".counter_dots span");
      if (nextImage) {
        allSpans.forEach((span, i) => {
          span.classList.remove("active");
          if (i === nextIndex) {
            span.classList.add("active");
          }
        });
        x.src = nextImage;
      } else {
        allSpans.forEach((span, i) => {
          span.classList.remove("active");
          if (i === 0) {
            span.classList.add("active");
          }
        });
        x.src = images[0];
      }
    });
  });

  //add eventlistener for big image
  document.querySelectorAll(".big-image").forEach((yy) => {
    yy.addEventListener("click", () => {
      // get the image from the button
      const x = yy.parentElement.parentElement.querySelector(".media img");
      const variantId = x.dataset.variantid;
      const images = window[variantId];
      const currentImage = x.src;
      const currentIndex = images.indexOf(currentImage);
      // show the large images full screen in a modal with id room-modals
      const modal = document.querySelector("#room-modals");
      modal.innerHTML = "";
      images.forEach((image, i) => {
        const modalImage = document.createElement("img");
        modalImage.src = image;
        modalImage.classList.add("modal-image" + i);
        if (i === currentIndex) {
          modalImage.classList.add("active");
          modal.appendChild(modalImage);
        }
      });
      // scroll current image into view
      const activeImage = modal.querySelector(".modal-image" + currentIndex);

      activeImage &&
        activeImage.scrollIntoView({ behavior: "smooth", block: "center" });
    });
  });

  //add eventlistener for prev image
  document.querySelectorAll(".prev-image").forEach((yy) => {
    yy.addEventListener("click", () => {
      // get the image from the button
      const x = yy.parentElement.parentElement.querySelector(".media img");
      const variantId = x.dataset.variantid;
      const images = window[variantId];
      const currentImage = x.src;
      const currentIndex = images.indexOf(currentImage);
      const nextIndex = currentIndex - 1;
      const nextImage = images[nextIndex];
      const allSpans =
        x.parentElement.parentElement.querySelectorAll(".counter_dots span");
      if (nextImage) {
        allSpans.forEach((span, i) => {
          span.classList.remove("active");
          if (i === nextIndex) {
            span.classList.add("active");
          }
        });
        x.src = nextImage;
      } else {
        allSpans.forEach((span, i) => {
          span.classList.remove("active");
          if (i === images.length - 1) {
            span.classList.add("active");
          }
        });
        x.src = images[images.length - 1];
      }
    });
  });

  // add event listener to all info buttons
  document.querySelectorAll("img").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      // check if open
      if (document.querySelector(".spotlight")) {
        return;
      }

      const infoPanel =
        e.target.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.classList.toggle(
          "spotlight",
        );

      document.querySelector(".backdrop").classList.add("show");
      const myHeaderz = document.querySelector("#room-header");
      if (myHeaderz) {
        myHeaderz.style.pointerEvents = "none";
      }
    });
  });

  // add event listener to all info panels
  document.querySelectorAll(".infoPanel .close").forEach((close) => {
    close.addEventListener("click", (e) => {
      document.querySelector(".spotlight").classList.toggle("spotlight");
      document.querySelector(".backdrop").classList.remove("show");

      const myHeaderz = document.querySelector("#room-header");
      if (myHeaderz) {
        myHeaderz.style.pointerEvents = "all";
      }
    });
  });
  activateNotifyButtons();
};
console.log("Coming soon ... 📆");
document.addEventListener("DOMContentLoaded", function () {
  console.log("Coming soon .sss.. 📆");
  const comingSoonUrl =
    window.location.hostname === "127.0.0.1"
      ? "http://localhost:8888/api/coming-soon-new-new?country=" +
        (Shopify?.country || "BE")
      : "https://the-room-app.vercel.app/api/coming-soon-new-new?country=" +
        (Shopify?.country || "BE");

  const comingSoonInCache = window.sessionStorage.getItem("comingSoonProducts");
  const newProductsInCache = window.sessionStorage.getItem("newProducts");
  const restockedProductsInCache =
    window.sessionStorage.getItem("restockedProducts");
  if (comingSoonInCache && comingSoonInCache !== "[]") {
    const comingSoonProducts = JSON.parse(comingSoonInCache);
    const newProducts = JSON.parse(newProductsInCache);
    const restockedProducts = JSON.parse(restockedProductsInCache);
    // console.log("🔥🔥🔥🔥comingSoonProducts", comingSoonProducts);
    addComingSoonBadges(comingSoonProducts);
    fillCarousel(comingSoonProducts);
    fillComingsoonPage(comingSoonProducts);
    setNewProductsBadge(newProducts, restockedProducts);
  } else {
    fetch(comingSoonUrl)
      .then((y) => y.json())
      .then((x) => {
        if (Array.isArray(x)) {
          const comingSoonProductsFromServer = x;
          window.sessionStorage.setItem(
            "comingSoonProducts",
            JSON.stringify(comingSoonProductsFromServer),
          );
          addComingSoonBadges(comingSoonProductsFromServer);
          fillCarousel(comingSoonProductsFromServer);
          fillComingsoonPage(comingSoonProductsFromServer);

          return;
        }
        console.log("???", x);
        const comingSoonProductsFromServer = x.comingsoon;
        const newProducts = x.newProducts;
        const restockedProducts = x.restockedProducts;
        window.sessionStorage.setItem(
          "comingSoonProducts",
          JSON.stringify(comingSoonProductsFromServer),
        );
        if (newProducts && Array.isArray(newProducts) && newProducts.length) {
          window.sessionStorage.setItem(
            "newProducts",
            JSON.stringify(newProducts),
          );
        }

        if (
          restockedProducts &&
          Array.isArray(restockedProducts) &&
          restockedProducts.length
        ) {
          window.sessionStorage.setItem(
            "restockedProducts",
            JSON.stringify(restockedProducts),
          );
        }
        window.comingSoonProducts = comingSoonProductsFromServer;
        //  console.log("🔥🔥🔥🔥", x);
        addComingSoonBadges(comingSoonProductsFromServer);
        fillCarousel(comingSoonProductsFromServer);
        fillComingsoonPage(comingSoonProductsFromServer);
        setNewProductsBadge(newProducts, restockedProducts);
      });
  }
});
//const comingSoonUrl = 'http://localhost:8888/api/coming-soon-new?country='  + (Shopify?.country || 'BE');
